import { Slider } from '@mui/material'
import { styled } from '@mui/system'

export const StyledSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.primary.main,
  height: theme.spacing(0.5),
  marginTop: theme.spacing(3),
  padding: '15px 0',
  '& .MuiSlider-valueLabel': {
    fontSize: 12,
    fontWeight: 'normal',
    top: 0,
    backgroundColor: 'unset',
    color: theme.palette.text.base,
    '&:before': {
      display: 'none',
    },
    '& *': {
      background: 'transparent',
      color: theme.palette.text.base,
    },
  },
}))
